import { Component, Input, OnInit } from '@angular/core';
import { IntegratorData, IntegratorSetting, IntegratorDailyData } from '@dmonitor/shared/response/sensor/integrator';
import { BaseComponent } from '@dmonitor/shared/index';
import { ModalController, ToastController, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentService } from '@dmonitor/services/index';

@Component({
  selector: 'integrator-hourlydata-dialog',
  templateUrl: 'hourlydata-dialog.component.pug',
  styleUrls: ['hourlydata-dialog.component.sass'],
})
export class HourlyDataDialogComponent extends BaseComponent implements OnInit {
  protected TRANSLATE_KEY: string = "page.equipment.integrator.hourlydata";
  @Input() Settings: IntegratorSetting;
  @Input() Day: string;
  @Input() EquipmentId: string;
  public MaxIndex = [];
  public MinIndex = [];
  public HourlyData: IntegratorDailyData[] = [];
  constructor(
    public modalController: ModalController,
    toastController: ToastController,
    loadingController: LoadingController,
    private equipmentService: EquipmentService,
    translateService: TranslateService) {
    super(toastController, loadingController, translateService);
  }
  public ngOnInit(): void {
    this.presentLoading();
    console.log(`EquipmentId: ${this.EquipmentId} day: ${this.Day}`);
    this.equipmentService.getIntegratorDailyStatisticData(this.EquipmentId, this.Day).subscribe(
      (res) => {
        this.HourlyData = res.result;
        if (this.HourlyData.length == 0) {
          this.dismissLoading();
          return;
        }
        let min = 999999999;
        let max = 0;
        for (let i = 0; i < 24; i++) {
          if (this.HourlyData[i] == null) {
            continue;
          }
          if (this.HourlyData[i].vm == null) {
            continue;
          }
          if (this.HourlyData[i].vm == '-') {
            continue;
          }
          const value = Number(this.HourlyData[i].vm);
          if (value < min) {
            min = value;
          }
          if (value > max) {
            max = value;
          }
        }

        for (let i = 0; i < 24; i++) {
          if (this.HourlyData[i] == null) {
            continue;
          }
          if (this.HourlyData[i].vm == null) {
            continue;
          }
          if (this.HourlyData[i].vm == '-') {
            continue;
          }
          const value = Number(this.HourlyData[i].vm);
          if (value == min) {
            this.MinIndex.push(i);
          }
          if (value == max) {
            this.MaxIndex.push(i);
          }
        }
        this.dismissLoading();
      },
      (err) => {
        this.dismissLoading();
        this.showErrorToast('', err);
      });
  }

  public dismiss() {
    this.modalController.dismiss();
  }

  public IsMinIndex(idx: number): boolean {
    for (let i = 0; i < this.MinIndex.length; i++) {
      if (this.MinIndex[i] == idx) {
        return true;
      }
    }
    return false;
  }

  public IsMaxIndex(idx: number): boolean {
    for (let i = 0; i < this.MaxIndex.length; i++) {
      if (this.MaxIndex[i] == idx) {
        return true;
      }
    }
    return false;
  }

}
